/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_3_DescInputs */

const en_mk_agent_3_desc = /** @type {(inputs: Mk_Agent_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run bystep sync and the wiki is rebuilt from your repo, so the agent plans against the code you actually have.`)
};

const id_mk_agent_3_desc = /** @type {(inputs: Mk_Agent_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalankan bystep sync dan wiki dibangun ulang dari repo-mu, jadi agent merencanakan berdasarkan kode yang benar-benar ada.`)
};

/**
* | output |
* | --- |
* | "Run bystep sync and the wiki is rebuilt from your repo, so the agent plans against the code you actually have." |
*
* @param {Mk_Agent_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_3_desc = /** @type {((inputs?: Mk_Agent_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_3_desc(inputs)
	return en_mk_agent_3_desc(inputs)
});